import { UserResponse } from '@sekoia/shared/requests/nswagClients/AtlasClient';
import atlasServiceUrl from '@sekoia/shared/utils/rest/atlasServiceUrl';
import ProfileStorageManager from 'src/utils/CurrentProfileProvider/ProfileStorageManager';
import { Authentication } from 'src/utils/authentication/Authentication';
import { ai } from '@sekoia/shared/utils/telemetryService';

interface IProfile {
  id: string;
  customerUrl?: string;
  customerId?: string;
  cultureInfoCode?: string;

  fullName: string;

  roles: string[];

  [key: string]: string | string[] | undefined;
}

/**
 * @deprecated Get customer information from `useProfileContext` instead.
 */
interface ICurrentProfileProvider {
  setCurrentProfile(
    profileId: string,
    customerId: string,
    customerUrl: string,
    cultureInfoCode: string,
  ): Promise<boolean>;
  getCurrentProfile(): IProfile | null;
  clearCurrentProfile(): void;
}

export default class CurrentProfileProvider implements ICurrentProfileProvider {
  private _profileStorageManager = new ProfileStorageManager();
  public static Instance: ICurrentProfileProvider = new CurrentProfileProvider();
  clearCurrentProfile(): void {
    this._profileStorageManager.removeCurrentProfile();
  }

  private async fetchUserData() {
    const baseUrl = atlasServiceUrl();
    const response = await fetch(`${baseUrl}/api/user`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${await Authentication.Instance.getToken()}`,
      },
    });
    const data = await response.json();
    return data as UserResponse;
  }

  public async setCurrentProfile(
    profileId: string,
    customerId: string,
    customerUrl: string,
    cultureInfoCode: string,
  ): Promise<boolean> {
    const currentProfile: IProfile = { id: profileId, roles: [], fullName: '' };
    currentProfile.customerUrl = customerUrl;
    currentProfile.customerId = customerId;
    currentProfile.cultureInfoCode = cultureInfoCode;

    const roles = await Authentication.Instance.getRolesOfCurrentUser();
    currentProfile.roles = roles;

    try {
      const userData = await this.fetchUserData();
      currentProfile.fullName = `${userData.firstName} ${userData.lastName}`;
    } catch (error) {
      ai.trackException(error, 'Error loading user');
    }

    this._profileStorageManager.setCurrentProfile(JSON.stringify(currentProfile));

    return true;
  }

  public getCurrentProfile() {
    const p = this._profileStorageManager.getCurrentProfile();
    const profile: IProfile | null = p ? JSON.parse(p) : null;

    if (!profile) {
      return null;
    }
    return profile;
  }
}
